import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

const Highlight = ({borderRadius = 0, height, width, x, y, opacity = 0, item, onHover}) => {
    const [hover, setHover] = useState(false);

    const handleMouseEnter = () => {
        setHover(true);
        onHover(item);
    }

    const handleMouseLeave = () => {
        setHover(false);
        onHover('');
    }

    return (
        <Link to={`/${item.toLowerCase()}`}>
            <div style={{
                borderRadius: borderRadius,
                backgroundColor: 'green',
                height: height + 'px',
                width: width + 'px',
                position: 'absolute',
                left: x + 'px',
                top: y + 'px',
                opacity: hover ? 0 : opacity,
            }}
                 onMouseEnter={handleMouseEnter}
                 onMouseLeave={handleMouseLeave}/>
        </Link>
    );
}

Highlight.propTypes = {
    borderRadius: PropTypes.number,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    opacity: PropTypes.number,
    item: PropTypes.string.isRequired,
    onHover: PropTypes.func.isRequired,
}

export default Highlight;
